<template>
    <router-link
        class="whitespace-nowrap"
        :to="{name: 'video.view', params: {id: video.id, slug: video.slug}}"
    >
        <div class="h-[180px] lg:h-[240px] rounded overflow-hidden">
            <img class="h-full w-full object-cover object-center" :src="thumbnail" alt=""/>
        </div>
        <div class="flex justify-between gap-4 mt-1">
            <div class="truncate">{{ video.title }}</div>
        </div>
    </router-link>
</template>

<script>
import secondsToMinutes from "../../../utils/secondsToMinutes";
import videoInfos from "../../../mixins/video-infos";
import getMinOrSecForSeconds from "../../../utils/getMinOrSecForSeconds";

export default {
    name: 'MoleculeVideosCard',
    methods: {getMinOrSecForSeconds, secondsToMinutes},
    mixins: [videoInfos],
    props: {
        video: {
            type: Object,
            required: true,
        }
    },
    mounted() {
        this.getVideoInfos(this.video)
    }
}
</script>
